// Temperature selector for clothing guide
document.addEventListener('DOMContentLoaded', () => {
  const subHeadingElement = document.querySelector('.clothing-guide__sub-heading') as HTMLElement;
  const temperatureSelect = subHeadingElement?.querySelector('#temperature-dropdown') as HTMLSelectElement;
  const recommendationElement = subHeadingElement?.querySelector('.clothing-guide__recommendation') as HTMLElement;
  const sliders = document.querySelectorAll('.clothing-guide__slider') as NodeListOf<HTMLElement>;
  const controls = document.querySelectorAll('.clothing-guide__external-controls [data-temperature]') as NodeListOf<HTMLElement>;
  
  if (!temperatureSelect || sliders.length === 0) {
    return;
  }

  // Function to build recommendation links to append to sub-heading
  const buildRecommendationLinks = (types: string[], links: string[]) => {
    return types.map((type, index) => {
      const link = links[index] ? `<a href="${links[index]}" class="clothing-guide__recommendation-link text-brand-red underline">${type.toLowerCase()}</a>` : type;
      return `<span class="clothing-guide__recommendation-type">${link}</span>`;
    }).join(' and ');
  };

  // Function to update recommendation content based on active slider
  const updateRecommendationContent = () => {
    const activeSlider = Array.from(sliders).find(slider => slider.dataset.active === 'true');
    if (!activeSlider || !recommendationElement) return;

    const recommendationTypes = activeSlider.dataset.recommendationTypes?.split(',') || [];
    const recommendationLinks = activeSlider.dataset.recommendationLinks?.split(',') || [];

    if (recommendationTypes.length > 0 && recommendationLinks.length === recommendationTypes.length) {
      const recommendationHTML = buildRecommendationLinks(recommendationTypes, recommendationLinks);
      recommendationElement.innerHTML = recommendationHTML;
    }
  };

  // Set initial active slider and recommendation content
  const firstSlider = sliders[0];
  if (firstSlider) {
    firstSlider.dataset.active = 'true';
    updateRecommendationContent();
  }

  // Handle temperature change
  temperatureSelect.addEventListener('change', (event) => {
    const selectedTemperature = (event.target as HTMLSelectElement).value;
    
    // Hide all sliders
    sliders.forEach(slider => {
      slider.style.display = 'none';
      slider.dataset.active = 'false';
    });
    
    // Show the selected temperature slider
    const targetSlider = document.querySelector(`[data-temperature="${selectedTemperature}"]`) as HTMLElement;
    if (targetSlider) {
      targetSlider.style.display = 'block';
      targetSlider.dataset.active = 'true';
      
      // Update recommendation content with active slider data
      updateRecommendationContent();
    }
  });
});
